module.exports = __webpack_public_path__ + "img/鱼腥草.72aaf3f2.jpg";